import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, Menu, MenuItem } from '@mui/material';
import React from 'react';
/**
 * A button for an action. If `onClick` is defined, then it's a button. If `menuItems` are defined, then it's a
 * drop-down button.
 */
export const ActionButton = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const [anchorEl, setAnchorEl] = React.useState();
    if (props.action.onClick || !props.action.menuItems) {
        return (React.createElement(Button, { fullWidth: props.fullWidth, variant: (_a = props.variant) !== null && _a !== void 0 ? _a : 'text', startIcon: props.action.icon, disabled: props.action.disabled, onClick: (event) => {
                if (props.stopPropagationOnClick) {
                    event.stopPropagation();
                }
                if (props.action.onClick) {
                    props.action.onClick();
                }
            }, tabIndex: props.tabIndex, sx: [{ whiteSpace: 'nowrap' }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])], "data-test": (_b = props.action['data-test']) !== null && _b !== void 0 ? _b : props['default-data-test'] }, props.action.label));
    }
    else {
        const handleClick = (event) => {
            if (props.stopPropagationOnClick) {
                event.stopPropagation();
            }
            setAnchorEl(event.currentTarget);
        };
        const handleClose = (event) => {
            if (props.stopPropagationOnClick) {
                event.stopPropagation();
            }
            setAnchorEl(undefined);
        };
        let allMenuItemsDisabled = true;
        for (const menuItem of props.action.menuItems) {
            if (!menuItem.disabled) {
                allMenuItemsDisabled = false;
                break;
            }
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { fullWidth: props.fullWidth, variant: (_c = props.variant) !== null && _c !== void 0 ? _c : 'text', startIcon: props.action.icon, endIcon: React.createElement(ArrowDropDownIcon, null), disabled: props.action.disabled || allMenuItemsDisabled, onClick: handleClick, tabIndex: props.tabIndex, sx: [{ whiteSpace: 'nowrap' }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])], "data-test": (_d = props.action['data-test']) !== null && _d !== void 0 ? _d : props['default-data-test'] }, props.action.label),
            React.createElement(Menu, { anchorEl: anchorEl, open: !!anchorEl, anchorOrigin: { horizontal: (_e = props.anchor) !== null && _e !== void 0 ? _e : 'left', vertical: 'bottom' }, transformOrigin: { horizontal: (_f = props.anchor) !== null && _f !== void 0 ? _f : 'left', vertical: 'top' }, onClose: handleClose }, props.action.menuItems.map((menuItem) => (React.createElement(MenuItem, { key: menuItem.label, disabled: menuItem.disabled, onClick: (event) => {
                    if (menuItem.onClick) {
                        event.preventDefault();
                        menuItem.onClick();
                    }
                    handleClose(event);
                }, "data-test": menuItem['data-test'] }, menuItem.label))))));
    }
};
